import Patients from "@/views/patients/index.vue";
import Patient from "@/views/patients/patient/index.vue";
import Attendances from "@/views/patients/patient/attendances.vue";
import Exams from "@/views/patients/patient/exams.vue";
import Treatments from "@/views/patients/patient/treatments.vue";
import Surgeries from "@/views/patients/patient/surgeries.vue";
import SurgeryIndications from "@/views/patients/patient/surgery_indications.vue";
import PatientData from "@/views/patients/patient_data/index.vue";

import DefaultLayout from "@/views/layouts/default.vue";

export default [
  {
    path: "/pacientes",
    component: DefaultLayout,
    children: [
      {
        path: "",
        name: "Lista de Pacientes",
        component: Patients,
      },
    ],
  },
  {
    path: "/pacientes/:patientId",
    name: "Paciente",
    props: true,
    component: Patient,
    redirect: {
      path: "/pacientes/:patientId/atendimentos",
    },
    children: [
      {
        path: "atendimentos",
        name: "Lista de atendimentos",
        component: Attendances,
      },
      {
        path: "exames",
        name: "Lista de exames",
        component: Exams,
      },
      {
        path: "tratamentos",
        name: "Lista de tratamentos",
        component: Treatments,
      },
      {
        path: "cirurgias",
        name: "Lista de cirurgias",
        component: Surgeries,
      },
      {
        path: "indicacoes-cirurgicas",
        name: "Lista de indicações cirúrgicas",
        component: SurgeryIndications,
      },
      {
        path: "dados-paciente",
        name: "Dados Paciente",
        component: PatientData,
      },
    ],
  },
];
